<!-- eslint-disable vue/no-v-html -->
<template>
    <footer class="footer footer-container text-center">
        <div class="container">
            <div class="p-5">
                <div class="col-sm">
                    <a href="/">
                        <img :src="basePath + footerLogoPath" alt="Morgan Logo White Logo" />
                    </a>

                    <p v-if="showAppVersion == true" class="text-white">Version {{ appVersion }}</p>
                </div>
            </div>
            <div class="p-2">
                <!-- Footer Links -->
                <ul class="list-inline">
                    <li class="list-inline-item pr-1">
                        <a href="/about-us/">{{ $t('layout.footer.aboutUs') }}</a>
                    </li>
                    <li class="list-inline-item pr-1">
                        <a href="/app/">{{ $t('layout.footer.app') }}</a>
                    </li>
                    <li class="list-inline-item pr-1">
                        <a href="/app-terms/">{{ $t('layout.footer.appTerms') }}</a>
                    </li>
                    <li class="list-inline-item pr-1">
                        <a href="/complaints/">{{ $t('layout.footer.complaints') }}</a>
                    </li>
                    <li class="list-inline-item pr-1">
                        <a href="/news/">{{ $t('layout.footer.news') }}</a>
                    </li>
                    <li class="list-inline-item pr-1">
                        <a href="/careers/">{{ $t('layout.footer.careers') }}</a>
                    </li>
                    <li class="list-inline-item pr-1">
                        <a href="/privacy-policy/">{{ $t('layout.footer.privacyPolicy') }}</a>
                    </li>
                    <li class="list-inline-item pr-1">
                        <a href="/cookie-policy/">{{ $t('layout.footer.cookiePolicy') }}</a>
                    </li>
                    <li class="list-inline-item pr-1">
                        <a href="/terms/">{{ $t('layout.footer.termsConditions') }}</a>
                    </li>
                    <li class="list-inline-item pr-1">
                        <a href="/faq/">{{ $t('layout.footer.FAQ') }}</a>
                    </li>
                    <li class="list-inline-item pr-1">
                        <a href="/sitemap/">{{ $t('layout.footer.sitemap') }}</a>
                    </li>
                    <!-- <li class="list-inline-item pr-1">
					<a href="/coronavirus-update/">Coronavirus</a>
				</li> -->
                    <li class="list-inline-item pr-1">
                        <a href="/downloads/">{{ $t('layout.footer.downloads') }}</a>
                    </li>
                    <!-- <li class="list-inline-item pr-1">
					<a href="/worldpay/">Worldpay</a>
				</li> -->
                </ul>
            </div>

            <!-- Footer Social Links -->
            <div class="p-2">
                <ul class="list-inline">
                    <li class="list-inline-item">
                        <a
                            href="https://www.facebook.com/morganpriceint/"
                            target="_blank"
                            title="https://www.facebook.com/morganpriceint/"
                            aria-label="https://www.facebook.com/morganpriceint/"
                            rel="noopener noreferrer"
                        >
                            <span class="fa-stack">
                                <i class="fas fa-stack-2x" />
                                <i class="fab fa-facebook-f fa-stack-1x fa-inverse" />
                            </span>
                        </a>
                    </li>
                    <li class="list-inline-item">
                        <a
                            href="https://www.instagram.com/morganpriceintl/"
                            target="_blank"
                            title="https://www.instagram.com/morganpriceintl/"
                            aria-label="https://www.instagram.com/morganpriceintl/"
                            rel="noopener noreferrer"
                        >
                            <span class="fa-stack">
                                <i class="fas fa-stack-2x" />
                                <i class="fab fa-instagram fa-stack-1x fa-inverse" />
                            </span>
                        </a>
                    </li>
                    <li class="list-inline-item">
                        <a
                            href="https://twitter.com/morganpriceint"
                            target="_blank"
                            title="https://twitter.com/morganpriceint"
                            aria-label="https://twitter.com/morganpriceint"
                            rel="noopener noreferrer"
                        >
                            <span class="fa-stack">
                                <i class="fas fa-stack-2x" />
                                <i class="fab fa-twitter fa-stack-1x fa-inverse" />
                            </span>
                        </a>
                    </li>
                    <li class="list-inline-item">
                        <a
                            href="https://www.linkedin.com/company/morgan-price-international-healthcare-ltd/"
                            target="_blank"
                            title="https://www.linkedin.com/company/morgan-price-international-healthcare-ltd/"
                            aria-label="https://www.linkedin.com/company/morgan-price-international-healthcare-ltd/"
                            rel="noopener noreferrer"
                        >
                            <span class="fa-stack">
                                <i class="fas fa-stack-2x" />
                                <i class="fab fa-linkedin-in fa-stack-1x fa-inverse" />
                            </span>
                        </a>
                    </li>
                </ul>
            </div>

            <!-- Back to top button -->
            <button id="back-to-top" class="btn btn-green back-to-top">
                <i class="fas fa-chevron-up" />
            </button>

            <!-- Copyright notice -->
            <div class="pt-2">
                <div class="text-white" v-html="footerAddress" />
            </div>
        </div>
    </footer>
</template>
<script>
import helper from '../../utils/helper'
import applyOnlineService from '../../api/services/applyOnlineService'
export default {
    // eslint-disable-next-line vue/no-reserved-component-names
    name: 'Footer',
    data() {
        return {
            basePath: helper.getBaseAssetPath(),
            footerLogoPath: '',
            footerAddress: '',
            showAppVersion: window.displayAppVersionNumber,
            appVersion: process.env.VUE_APP_VERSION,
        }
    },
    mounted() {
        applyOnlineService.getSpecificConfigLayoutAsync().then((result) => {
            this.footerLogoPath = result.footerLogoPath
            this.footerAddress = result.footerAddress
        })
    },
}
</script>
<style lang="scss" scoped>
.footer-container {
    position: relative;
    background-color: var(--mp-footer);
    height: auto;
    padding-bottom: 2em;
    // white-space: pre-wrap;
}
</style>
